import builder from 'xmlbuilder'
import { downloadFile } from '../util/download.service'

export default function buildXmlOrtec(entregas) {
  const root = builder.create('comtec', { version: '1.0', encoding: 'UTF-8' })
  const suborders = root.ele('suborders')
  entregas.forEach((e, index) => {
    const suborder = suborders.ele('suborder')
    suborder.ele('nameColog', {}, e.company_name)
    suborder.ele('CNPJColog', {}, e.company_cnpj)
    suborder.ele('pedido', {}, e.loteCarregamento)
    suborder.ele('dataEmissao', {}, e.dataEmissao)
    suborder.ele('CNPJCliente', {}, e.cnpj_cliente)
    suborder.ele('pesoBruto', {}, e.weightTotal.toString().replace('.', ','))
    suborder.ele('pallets', {}, e.volumeM3.toString().replace('.', ','))
    suborder.ele('produto', {}, 99999) // SEMPRE
    suborder.ele('lote', {}, '') // SEMPRE
    suborder.ele('quantidadeRemessa', {}, e.qteSkuTotal.toString().replace('.', ','))
    suborder.ele('tipoColeta', {}, '') // SEMPRE
    suborder.ele('t1t2', {}, 'T1') //SEMPRE
    suborder.ele('quantidadeNFs', {}, '1') //SEMPRE
    suborder.ele('CD', {}, '2414') // SEMPRE
    suborder.ele('SHIPP', {}, '2461') //SEMPRE
    suborder.ele('numeroNF', {}, preencherComZeros(e.nota_fiscal, 10)) // Por padrao a  NF deve ter 10 caracteres
    suborder.ele('serieNF', {}, 1) // SEMPRE
    suborder.ele('CNPJEmitente', {}, e.company_cnpj)
    suborder.ele('CNPJDestinatario', {}, e.cnpj_cliente)
    suborder.ele('rowNumber', {}, index + 1)
  })

  const xml = root.end({ pretty: true, allowEmpty: true })
  const blob = new Blob([xml], { type: 'text/xml' })
  downloadFile(blob, 'tpmanager_ortec_interface.xml')
}

function preencherComZeros(info, qteCaracteres) {
  const quantidadeDeZerosNecessarios = qteCaracteres - info.length
  if (quantidadeDeZerosNecessarios > 0) {
    let zeros = ''
    for (let i = 0; i < quantidadeDeZerosNecessarios; i++) {
      zeros += '0'
    }
    return zeros + info
  } else {
    return info
  }
}
